import { render } from "./Exchange.vue?vue&type=template&id=c9a3f7d8&scoped=true"
import script from "./Exchange.vue?vue&type=script&lang=js"
export * from "./Exchange.vue?vue&type=script&lang=js"

import "./Exchange.vue?vue&type=style&index=0&id=c9a3f7d8&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9a3f7d8"]])

export default __exports__